import { render, staticRenderFns } from "./DrawSignature.vue?vue&type=template&id=5f231f81&"
import script from "./DrawSignature.vue?vue&type=script&lang=js&"
export * from "./DrawSignature.vue?vue&type=script&lang=js&"
import style0 from "./DrawSignature.vue?vue&type=style&index=0&id=5f231f81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports